import { render, staticRenderFns } from "./DetailAnimationButton.vue?vue&type=template&id=23319008&scoped=true&"
import script from "./DetailAnimationButton.vue?vue&type=script&lang=js&"
export * from "./DetailAnimationButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailAnimationButton.vue?vue&type=style&index=0&id=23319008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23319008",
  null
  
)

export default component.exports